import { render } from "./OverlayWrapper.vue?vue&type=template&id=652bc61e"
import script from "./OverlayWrapper.vue?vue&type=script&lang=js"
export * from "./OverlayWrapper.vue?vue&type=script&lang=js"

import "./OverlayWrapper.vue?vue&type=style&index=0&id=652bc61e&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__